

import controller from './contracts.controller';
import ContractsService from './contracts.service'

export default function (app) {
	app.service('ContractsService', ContractsService);
	app.component('contracts', {
		templateUrl: 'contracts/contracts',
		bindings: {
			type: '@',
		},
		controller:['ContractsService',controller]
	});
};

